<template>
    <div>
        <router-view name="demandModal"></router-view>
        <demand-filter
            class="mb-4"
            :filters.sync="filters"
            @get-data-from-api="loadData()"
        ></demand-filter>
        <v-card>
            <v-card-title>
                <v-btn
                color="primary"
                class="mb-2"
                :disabled="dataTable.loading"
                :to="{ name: 'CadastrarDemanda' }"
            >
                    <v-icon>add</v-icon>{{ $t('demand.list.addItem')}}
                </v-btn>
                <v-divider class="mx-3 hidden-md-and-down mt-0" inset vertical></v-divider>
                <v-text-field
                    v-model="search.query"
                    @click:clear="clearQuery"
                    @keyup.enter="loadData()"
                    type="text"
                    prepend-icon="search"
                    :label="$t('common.search.field')"
                    clear-icon="cancel"
                    clearable
                    hide-details
                    solo
                ></v-text-field>

                <v-btn class="ml-2" color="primary" :disabled="!search.ready" @click="loadData()">{{ $t('common.search.button') }}</v-btn>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <data-table :setup.sync="dataTable"></data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import DemandFilter from '@/components/DemandFilter'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-demands',
    metaInfo () {
        return {
            title: this.$t('demand.list.meta.title'),
            meta: [
                { name: 'description', content: this.$t('demand.list.meta.description') },
                { name: 'keywords', content: this.$t('demand.list.meta.keywords') }
            ]
        }
    },
    components: {
        DemandFilter,
        DataTable
    },
    data () {
        return {
            isAdmin: false,
            filters: {
                ready: false,
                fromDate: undefined,
                toDate: undefined,
                client: [],
                responsible: [],
                createdBy: [],
                status: []
            },
            search: {
                ready: true,
                query: ''
            },
            dataTable: {
                loading: true,
                itemName: this.$t('demand.list.dataTable.itemName'),
                headers: [
                    { text: this.$t('demand.list.dataTable.headers.client'), value: 'client.name', width: '12%' },
                    {
                        text: this.$t('demand.list.dataTable.headers.startDate'),
                        value: 'startDate',
                        width: '8%',
                        align: 'center',
                        date: 'iso'
                    },
                    { text: this.$t('demand.list.dataTable.headers.demand'), value: 'demand', width: '22%' },
                    {
                        text: this.$t('demand.list.dataTable.headers.currentTask'),
                        value: 'currentTask',
                        width: '15%',
                        align: 'center',
                        sortable: false
                    },
                    {
                        text: this.$t('demand.list.dataTable.headers.nextTask'),
                        value: 'nextTask',
                        width: '15%',
                        align: 'center',
                        sortable: false
                    },
                    {
                        text: this.$t('demand.list.dataTable.headers.deadlineDate'),
                        value: 'deadlineDate',
                        width: '8%',
                        align: 'center',
                        date: 'iso'
                    },
                    { text: this.$t('demand.list.dataTable.headers.status'), value: 'status', width: '10%', align: 'center' },
                    {
                        text: this.$t('demand.list.dataTable.headers.responsible'),
                        value: 'responsible.user.name',
                        width: '10%',
                        align: 'center',
                        background: 'responsible.profile.color'
                    }
                ],
                items: [],
                totalItems: 0,
                detailTo: 'DetalheDemanda',
                editTo: 'EditarDemanda',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: [
                        'deadlineDate',
                        'client.name',
                        'startDate',
                        'responsible.user.name',
                        'status',
                        'demand'
                    ],
                    sortDesc: [false, false, false, false, false, false],
                    sortFormated: [
                        { value: 'deadlineDate', descending: false },
                        { value: 'client', descending: false },
                        { value: 'startDate', descending: false },
                        { value: 'responsible', descending: false },
                        { value: 'status', descending: false },
                        { value: 'demand', descending: false }
                    ]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        '$route.path': {
            handler: function (val, oldVal) {
                if (oldVal !== val && val === '/demandas') {
                    if (window.getApp.refreshDemands) this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) {
                        clearTimeout(this.dataTable.sortingTimeout)
                    }
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.adminOnly()
        if (!window.getApp.isEmployee) {
            this.loadData()
        }
    },
    computed: {
        isEmployee: function () {
            return window.getApp.isEmployee
        }
    },
    methods: {
        adminOnly () {
            if (this.$helpers.isAdmin()) {
                this.isAdmin = true
            }
        },
        clearQuery () {
            this.search.query = ''
            this.loadData()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            window.getApp.refreshDemands = false
            this.dataTable.loading = true
            this.search.ready = false
            this.filters.ready = false
            let endpoint = API.EndPoints.getAllDemand
            let params = {
                query: this.search.query,
                limit: this.dataTable.pagination.itemsPerPage,
                skip: this.dataTable.pagination.page - 1,
                order: this.dataTable.pagination.sortFormated,
                fromDate: this.filters.fromDate,
                toDate: this.filters.toDate,
                client: this.filters.client,
                manager: this.filters.manager,
                department: this.filters.department,
                responsible: this.filters.responsible,
                status: this.filters.status,
                isEmployee: this.isEmployee,
                owner: currentUserCompany.client.objectId
            }

            if (currentUserCompany.client.type === 'department') {
                params.department = [currentUserCompany.client.objectId]
                params.owner = currentUserCompany.client.parent.objectId
            }

            new API(endpoint, params).request().then(
                response => {
                    this.dataTable.items = response.body.result.items
                    this.dataTable.totalItems = response.body.result.count
                    this.search.ready = true
                    this.filters.ready = true
                    this.dataTable.loading = false
                    this.dataTable.sortingTimeout = undefined
                },
                e => {
                    this.$helpers.requestError(e)
                }
            )
        }
    }
}
</script>
